function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { useMemo } from 'react';
import './SimpleGroupTemplate.css';
import ExpandArraysContext from '../ExpandArraysContext';
import ValidateErrorsContext from '../ValidationForm/ValidateErrorsContext';
import GroupGridGroupsProvider, { GroupGridGroupsContext } from './GroupGridGroupsContext';
import getDisplayName from '../../getDisplayName';
import { wrapGroupTemplate, GroupContentTemplate } from './SimpleGroupTemplate';
var isArray = function isArray(tbd) {
  return Array.isArray(tbd);
};
var isElement = function isElement(tbd) {
  return typeof tbd.props !== undefined;
};
function flattenGroupChildren(children, containerId, $id, isInDsa) {
  var result = [];
  if (isArray(children)) {
    children.forEach(function (child) {
      if (isElement(child)) {
        if (child.props.type === 'group') {
          result = result.concat(flattenGroupChildren(child.props.children, containerId, $id, isInDsa));
        } else {
          var childKey = ".".concat(child.key);
          if (containerId) {
            if (isInDsa) {
              var _indexMatch = $id.match(/\d+$/);
              var _arrayIndex = _indexMatch && _indexMatch.length ? _indexMatch[0] : $id;
              childKey = ".".concat(containerId, "[").concat(_arrayIndex, "].").concat(child.key);
            } else {
              childKey = "".concat(containerId, ".").concat(child.key);
            }
          }
          result.push(childKey);
        }
      }
    });
  }
  return result;
}
var BaseGroupTitleField = function BaseGroupTitleField(props) {
  var TitleField = props.TitleField,
    uiSchema = props.uiSchema,
    idSchema = props.idSchema,
    formContext = props.formContext,
    expandArrays = props.expandArrays,
    errors = props.errors,
    labelId = props.labelId,
    groupUiIcons = props.groupUiIcons,
    gridGroups = props.gridGroups,
    isCompact = props.isCompact,
    groupChildren = props.groupChildren;
  var defaultOpen = expandArrays.defaultOpen,
    openOnError = expandArrays.openOnError;
  var expandForErrors = useMemo(function () {
    var groupErrors = [];
    if (openOnError && errors.length) {
      var $id = idSchema.$id;
      var containerId = $id ? idSchema.$id.substring(1).replace(/_\d+$/, '') : undefined;
      var isInDsa = $id ? /_\d+$/.test($id) : false;
      var childErrorProperties = flattenGroupChildren(groupChildren, containerId, $id, isInDsa);
      groupErrors = errors.filter(function (error) {
        return childErrorProperties.indexOf(error.property) !== -1;
      });
    }
    return groupErrors.length > 0;
  }, [openOnError, errors, idSchema]);
  return /*#__PURE__*/React.createElement(TitleField, {
    defaultOpen: defaultOpen,
    expandForErrors: expandForErrors,
    id: labelId,
    idSchema: idSchema,
    title: props.text || '',
    escape: props.escape,
    formContext: formContext,
    help: uiSchema ? uiSchema['ui:help'] : '',
    groupUiIcons: groupUiIcons,
    isGroup: true
  }, /*#__PURE__*/React.createElement(GroupContentTemplate, {
    isCompact: isCompact,
    gridGroups: gridGroups
  }));
};
function wrapAccordionGroupTitleWidget(WrappedComponent) {
  var _Class;
  return _Class = /*#__PURE__*/function (_React$Component) {
    _inherits(_Class, _React$Component);
    function _Class() {
      _classCallCheck(this, _Class);
      return _possibleConstructorReturn(this, _getPrototypeOf(_Class).apply(this, arguments));
    }
    _createClass(_Class, [{
      key: "render",
      value: function render() {
        var _this = this;
        return /*#__PURE__*/React.createElement(ExpandArraysContext.Consumer, null, function (expandArraysContext) {
          return /*#__PURE__*/React.createElement(ValidateErrorsContext.Consumer, null, function (errors) {
            return /*#__PURE__*/React.createElement(GroupGridGroupsContext.Consumer, null, function (gridGroups) {
              return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
                expandArrays: expandArraysContext,
                errors: errors,
                gridGroups: gridGroups
              }, _this.props));
            });
          });
        });
      }
    }]);
    return _Class;
  }(React.Component), _Class.displayName = "WrapAccordionGroupTitleWidget(".concat(getDisplayName(WrappedComponent), ")"), _Class;
}
export var AccordionGroupTitleField = wrapAccordionGroupTitleWidget(BaseGroupTitleField);
function BaseAccordionGroupTemplate(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, ["children"]);
  var isCardView = props.formContext.isCardView;
  return /*#__PURE__*/React.createElement(GroupGridGroupsProvider, {
    groupChildren: children,
    isCardView: isCardView
  }, /*#__PURE__*/React.createElement(AccordionGroupTitleField, Object.assign({
    groupChildren: children
  }, rest)));
}
export default wrapGroupTemplate(BaseAccordionGroupTemplate);